export { renderCard_unstable as renderCard } from '@fluentui/react-card';
